import getAllowDownload from './getAllowDownload';
import getSupportedPermissionLevels from './getSupportedPermissionLevels';
import AttachmentClass from '../../store/schema/AttachmentClass';
import AttachmentInfo from '../../store/schema/AttachmentInfo';
import createSharingInfoFromGetSharingInfoResponse from '../../utils/createSharingInfoFromGetSharingInfoResponse';
import { createAttachmentPermissionLevelsFromSharingInfo } from 'owa-attachment-permission';
import { AttachmentPolicyInfo } from 'owa-attachment-policy';
import { getExtensionFromFileName } from 'owa-file';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import GetSharingInfoResponse from 'owa-service/lib/contract/GetSharingInfoResponse';
import { SharingInfo } from 'owa-sharing-data';

export default function createAttachmentInfo(
    attachmentPolicyInfo: AttachmentPolicyInfo,
    attachmentClass: AttachmentClass,
    attachment: AttachmentType,
    isCloudy: boolean,
    providerType: string | null,
    permissionInfo: GetSharingInfoResponse = null
): AttachmentInfo {
    const extension = getExtensionFromFileName(attachment.Name);
    const allowDownload = getAllowDownload(attachmentPolicyInfo, attachment, extension);
    const supportedPermissionLevels = getSupportedPermissionLevels(
        isCloudy,
        providerType,
        createAttachmentPermissionLevelsFromSharingInfo(permissionInfo)
    );
    const sharingInfo: SharingInfo = createSharingInfoFromGetSharingInfoResponse(permissionInfo);

    if (attachmentClass === AttachmentClass.Blocked) {
        return createBlockedAttachmentInfo();
    }

    if (isCloudy) {
        return createReferenceGenericAttachmentInfo(
            allowDownload,
            supportedPermissionLevels,
            sharingInfo
        );
    }
    return createClassicGenericAttachmentInfo(allowDownload);
}

function createClassicGenericAttachmentInfo(allowDownload: boolean): AttachmentInfo {
    return {
        allowDownload: allowDownload,
        supportedPermissionLevels: null,
        sharingInfo: null,
    };
}

function createReferenceGenericAttachmentInfo(
    allowDownload: boolean,
    supportedPermissionLevels: AttachmentPermissionLevel[],
    sharingInfo: SharingInfo
): AttachmentInfo {
    return {
        allowDownload: allowDownload,
        supportedPermissionLevels: supportedPermissionLevels,
        sharingInfo: sharingInfo,
    };
}

function createBlockedAttachmentInfo(): AttachmentInfo {
    return {
        allowDownload: false,
        supportedPermissionLevels: null,
        sharingInfo: null,
    };
}
